module.exports = __webpack_public_path__ + "media/images/img_side_toushi-5ca928a69b843579c7136d2f98b6265a.png";